import React from "react";
import "./BlogDesc.css";

const BlogDesc = () => {
  return (
    <section className="blog-intro">
      <h1 className="blog-title">Blog da Eliandro</h1>
      <p className="blog-description">
        Saiba mais sobre o mercado de food service com a maior distribuidora do Brasil. 
        Por aqui, contamos histórias, inspiramos pessoas e trazemos dicas fundamentais 
        para o seu negócio. Tudo com base nos nossos mais de 20 mil clientes. Vamos juntos?
      </p>
    </section>
  );
};

export default BlogDesc;
